var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetadata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C3149;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.4,12.2c-1-2.4-2.4-4.5-4.3-6.4c-1.8-1.8-4-3.3-6.4-4.3C25.3,0.5,22.7,0,20,0s-5.3,0.5-7.8,1.6 C9.8,2.6,7.7,4,5.9,5.9c-1.8,1.8-3.3,4-4.3,6.4C0.5,14.7,0,17.3,0,20c0,2.7,0.5,5.3,1.6,7.8c1,2.4,2.4,4.5,4.3,6.4 c1.8,1.8,4,3.3,6.4,4.3c2.5,1,5.1,1.6,7.8,1.6c2.7,0,5.3-0.5,7.8-1.6c2.4-1,4.5-2.4,6.4-4.3c1.8-1.8,3.3-4,4.3-6.4 c1-2.5,1.6-5.1,1.6-7.8C40,17.3,39.5,14.7,38.4,12.2z M27,36.6c-2.2,0.9-4.5,1.4-7,1.4c-9.9,0-18-8.1-18-18S10.1,2,20,2 s18,8.1,18,18C38,27.4,33.5,33.9,27,36.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,20.3c-0.2-0.2-0.2-0.5,0-0.6l5.5-5.5c0.4-0.4,0.4-1.2,0-1.6c-0.2-0.2-0.5-0.3-0.8-0.3 c-0.3,0-0.6,0.1-0.8,0.3l-6.8,6.8c-0.4,0.4-0.4,0.9,0,1.3l6.8,6.8c0.4,0.4,1.2,0.4,1.6,0c0.2-0.2,0.3-0.5,0.3-0.8 c0-0.3-0.1-0.6-0.3-0.8L8.1,20.3L8.1,20.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,9.7c-0.6-0.2-1.2,0.1-1.5,0.7l-7.1,18.5c-0.2,0.6,0.1,1.2,0.7,1.5c0.6,0.2,1.2-0.1,1.5-0.7l7.1-18.5 c0.1-0.1,0.1-0.3,0.1-0.4C24.7,10.3,24.4,9.8,24,9.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.8,19.4L28,12.5c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.4,0.4-0.4,1.2,0,1.6l5.5,5.5 c0.2,0.2,0.2,0.5,0,0.6l-5.5,5.5c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.6,0.3,0.8c0.4,0.4,1.2,0.4,1.6,0l6.8-6.8 C35.1,20.3,35.1,19.7,34.8,19.4L34.8,19.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetadata);
export default __webpack_public_path__ + "static/media/icon-metadata.300105a7001c76086bb9f01c87fee3c4.svg";
export { ForwardRef as ReactComponent };